import { NumberParam, type QueryParamConfigMap, StringParam, withDefault } from 'serialize-query-params';

import { GetOrganizationItemsParams } from '@/api/generated';
import { DEFAULT_PAGINATION } from '@/hooks/useEntityList';

export type GetOrganizationItemsRequestParams = GetOrganizationItemsParams & typeof DEFAULT_PAGINATION;

export const DEFAULT_VALUES = {
  ...DEFAULT_PAGINATION
} as GetOrganizationItemsRequestParams;

export const URL_CONFIG_MAP = {
  locationSlug: withDefault(StringParam, ''),
  locationType: withDefault(StringParam, ''),
  size: withDefault(NumberParam, DEFAULT_PAGINATION.size)
} satisfies QueryParamConfigMap;
